import cx from 'classnames';
import { bool, node, oneOf, string } from 'prop-types';
import React, { useRef, forwardRef, useLayoutEffect } from 'react';
import Icon from '../Icon';
import ColorMap from '../../mixins/colorMap';
import style from './Checkbox.module.scss';

const Checkbox = forwardRef(
  (
    { children, checked, textColor = 'Dark Neutral 1', className, indeterminate, ...rest },
    userRef,
  ) => {
    const defaultRef = useRef();
    const ref = userRef || defaultRef;

    useLayoutEffect(() => {
      ref.current.indeterminate = indeterminate;
    }, [ref, indeterminate]);

    return (
      <label className={cx(style.label, className)}>
        <input type="checkbox" checked={checked} className={style.input} ref={ref} {...rest} />
        <span className={style.shape}>
          {checked && !indeterminate && (
            <Icon className={style.checkedIcon} name="tick" size={12} />
          )}
        </span>
        {children && (
          <span className={style.text} style={{ color: ColorMap[textColor] }}>
            {children}
          </span>
        )}
      </label>
    );
  },
);

Checkbox.propTypes = {
  textColor: oneOf(['Dark Neutral 1', 'Mid Neutral 1']),
  children: node,
  checked: bool,
  indeterminate: bool,
  className: string,
};

export default Checkbox;
